<div class="channel-product-mapping-search-data-cell-editor__wrapper">
  <input
    matInput
    class="w-100"
    [placeholder]="formattedSelectedItem"
    [formControl]="searchControl"
    lumDebounceTime
    (debounceValue)="onSearch($event)"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedItem">
    <mat-option
      *ngFor="let uom of uoms$ | async; trackBy: trackById"
      [value]="uom"
      (click)="selectValue(uom)"
    >
      {{ uom.name }}
    </mat-option>
  </mat-autocomplete>
  <button
    *ngIf="selectedItem && !(loadingUoms$ | async)"
    mat-icon-button
    type="button"
    aria-label="Clear"
    class="clear-button"
    (click)="removeSelectedItem()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-progress-spinner
    *ngIf="loadingUoms$ | async"
    class="progress-spinner"
    diameter="16"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
